import React from 'react';

const Blur = () => {
    return (
        <div id="blur2"></div>
    );
}

export default Blur;